// extracted by mini-css-extract-plugin
export default {"wrapper":"Interface_wrapper__3PlOg","title":"Interface_title__LEdH0","titleWrapper":"Interface_titleWrapper__yhhs0"};